var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavyblack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 1139,
    viewBox: "0 0 1280 1139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1096,
    fill: "#121010"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1295 879.47C1295 879.47 866.675 270.542 689 434.202C609.673 507.273 665.226 616.421 588 691.724C411.038 864.282 223.76 262.466 23.5 407.095C-86.19 486.316 -124 721.342 -124 721.342",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 887.57C1295 887.57 866.675 278.643 689 442.303C609.673 515.373 665.226 624.522 588 699.825C411.038 872.383 223.76 270.566 23.5 415.196C-86.19 494.417 -124 729.443 -124 729.443",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 895.671C1295 895.671 866.675 286.743 689 450.404C609.673 523.474 665.226 632.621 588 707.926C411.038 880.484 223.76 278.667 23.5 423.296C-86.19 502.518 -124 737.544 -124 737.544",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 903.769C1295 903.769 866.675 294.842 689 458.502C609.673 531.572 665.226 640.72 588 716.024C411.038 888.582 223.76 286.765 23.5 431.395C-86.19 510.617 -124 745.641 -124 745.641",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 911.869C1295 911.869 866.675 302.942 689 466.603C609.673 539.672 665.226 648.821 588 724.124C411.038 896.682 223.76 294.866 23.5 439.495C-86.19 518.717 -124 753.742 -124 753.742",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 919.97C1295 919.97 866.675 311.043 689 474.703C609.673 547.773 665.226 656.921 588 732.225C411.038 904.783 223.76 302.966 23.5 447.596C-86.19 526.818 -124 761.843 -124 761.843",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 928.071C1295 928.071 866.675 319.143 689 482.804C609.673 555.874 665.226 665.022 588 740.326C411.038 912.884 223.76 311.067 23.5 455.696C-86.19 534.918 -124 769.943 -124 769.943",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 936.17C1295 936.17 866.675 327.242 689 490.903C609.673 563.973 665.226 673.12 588 748.425C411.038 920.982 223.76 319.165 23.5 463.795C-86.19 543.016 -124 778.042 -124 778.042",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 944.269C1295 944.269 866.675 335.342 689 499.002C609.673 572.072 665.226 681.22 588 756.524C411.038 929.083 223.76 327.266 23.5 471.895C-86.19 551.117 -124 786.142 -124 786.142",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 952.37C1295 952.37 866.675 343.443 689 507.103C609.673 580.173 665.226 689.321 588 764.625C411.038 937.184 223.76 335.366 23.5 479.996C-86.19 559.218 -124 794.242 -124 794.242",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 960.469C1295 960.469 866.675 351.541 689 515.202C609.673 588.272 665.226 697.42 588 772.724C411.038 945.282 223.76 343.465 23.5 488.094C-86.19 567.317 -124 802.341 -124 802.341",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 968.569C1295 968.569 866.675 359.641 689 523.302C609.673 596.372 665.226 705.52 588 780.824C411.038 953.382 223.76 351.565 23.5 496.195C-86.19 575.416 -124 810.442 -124 810.442",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 976.67C1295 976.67 866.675 367.742 689 531.403C609.673 604.473 665.226 713.62 588 788.925C411.038 961.483 223.76 359.666 23.5 504.295C-86.19 583.517 -124 818.542 -124 818.542",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 984.77C1295 984.77 866.675 375.842 689 539.503C609.673 612.573 665.226 721.72 588 797.025C411.038 969.583 223.76 367.766 23.5 512.396C-86.19 591.617 -124 826.643 -124 826.643",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 992.869C1295 992.869 866.675 383.941 689 547.602C609.673 620.672 665.226 729.82 588 805.124C411.038 977.682 223.76 375.865 23.5 520.494C-86.19 599.717 -124 834.741 -124 834.741",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1000.97C1295 1000.97 866.675 392.042 689 555.702C609.673 628.772 665.226 737.92 588 813.224C411.038 985.782 223.76 383.965 23.5 528.595C-86.19 607.817 -124 842.842 -124 842.842",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1009.07C1295 1009.07 866.675 400.142 689 563.803C609.673 636.873 665.226 746.021 588 821.325C411.038 993.883 223.76 392.066 23.5 536.695C-86.19 615.917 -124 850.942 -124 850.942",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1017.17C1295 1017.17 866.675 408.243 689 571.903C609.673 644.973 665.226 754.122 588 829.425C411.038 1001.98 223.76 400.166 23.5 544.796C-86.19 624.017 -124 859.043 -124 859.043",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1025.27C1295 1025.27 866.675 416.341 689 580.002C609.673 653.072 665.226 762.219 588 837.524C411.038 1010.08 223.76 408.265 23.5 552.894C-86.19 632.116 -124 867.141 -124 867.141",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1033.37C1295 1033.37 866.675 424.442 689 588.102C609.673 661.172 665.226 770.32 588 845.624C411.038 1018.18 223.76 416.366 23.5 560.995C-86.19 640.217 -124 875.242 -124 875.242",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1041.47C1295 1041.47 866.675 432.542 689 596.203C609.673 669.273 665.226 778.421 588 853.725C411.038 1026.28 223.76 424.466 23.5 569.095C-86.19 648.318 -124 883.342 -124 883.342",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1049.57C1295 1049.57 866.675 440.641 689 604.301C609.673 677.371 665.226 786.52 588 861.823C411.038 1034.38 223.76 432.565 23.5 577.194C-86.19 656.416 -124 891.441 -124 891.441",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1057.67C1295 1057.67 866.675 448.741 689 612.402C609.673 685.472 665.226 794.619 588 869.924C411.038 1042.48 223.76 440.665 23.5 585.294C-86.19 664.516 -124 899.541 -124 899.541",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1065.77C1295 1065.77 866.675 456.841 689 620.503C609.673 693.573 665.226 802.72 588 878.025C411.038 1050.58 223.76 448.765 23.5 593.395C-86.19 672.616 -124 907.642 -124 907.642",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1073.87C1295 1073.87 866.675 464.941 689 628.601C609.673 701.671 665.226 810.819 588 886.123C411.038 1058.68 223.76 456.864 23.5 601.493C-86.19 680.716 -124 915.74 -124 915.74",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1081.97C1295 1081.97 866.675 473.041 689 636.701C609.673 709.771 665.226 818.92 588 894.223C411.038 1066.78 223.76 464.965 23.5 609.594C-86.19 688.816 -124 923.841 -124 923.841",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1090.07C1295 1090.07 866.675 481.141 689 644.802C609.673 717.872 665.226 827.02 588 902.324C411.038 1074.88 223.76 473.065 23.5 617.694C-86.19 696.917 -124 931.941 -124 931.941",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1098.17C1295 1098.17 866.675 489.242 689 652.903C609.673 725.973 665.226 835.12 588 910.425C411.038 1082.98 223.76 481.165 23.5 625.795C-86.19 705.016 -124 940.042 -124 940.042",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1106.27C1295 1106.27 866.675 497.34 689 661.001C609.673 734.071 665.226 843.218 588 918.523C411.038 1091.08 223.76 489.264 23.5 633.894C-86.19 713.115 -124 948.141 -124 948.141",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1114.37C1295 1114.37 866.675 505.441 689 669.101C609.673 742.171 665.226 851.32 588 926.623C411.038 1099.18 223.76 497.365 23.5 641.994C-86.19 721.216 -124 956.241 -124 956.241",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1122.47C1295 1122.47 866.675 513.541 689 677.202C609.673 750.272 665.226 859.42 588 934.724C411.038 1107.28 223.76 505.465 23.5 650.094C-86.19 729.317 -124 964.341 -124 964.341",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1130.57C1295 1130.57 866.675 521.642 689 685.302C609.673 758.372 665.226 867.521 588 942.824C411.038 1115.38 223.76 513.566 23.5 658.195C-86.19 737.417 -124 972.442 -124 972.442",
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1138.67C1295 1138.67 866.675 529.741 689 693.401C609.673 766.471 665.226 875.619 588 950.923C411.038 1123.48 223.76 521.664 23.5 666.294C-86.19 745.515 -124 980.541 -124 980.541",
    stroke: "#E7E7E7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyblack);
export default __webpack_public_path__ + "static/media/wavyblack.e4e159505310bbaa28bab8970e0849f7.svg";
export { ForwardRef as ReactComponent };